import Vue from 'vue'
import App from './App'
import router from './router'
import 'normalize.css'
import './lib/element-theme/index.css'
import './i18n'
import './config'
import './style/global.styl'
import lineClamp from 'vue-line-clamp'
import 'babel-polyfill'
import 'es6-promise/auto'
import particles from 'particles.js'

Vue.use(particles)

Vue.config.productionTip = false

Vue.use(lineClamp)

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
